import React from "react";
import PlusMinButtons from "../../common/PlusMinButtons";
import Row from "../../common/Row";
import PropTypes from "prop-types";
import AutoComplete from "../../common/AutoComplete";

const GemeenteComponent = (props) => {
    const {
        gemeente,
        hoofdgemeenten,
        minButtonEnabled,
        plusButtonEnabled,
        disabled,
        onPlusButtonClick,
        onMinButtonClick,
        onChange,
        index,
        errors,
        validationMessageType
    } = props;

    return (
        <Row>
            <AutoComplete
                name={"gemeenteId_" + index}
                label="Hoofdgemeente"
                size={5}
                items={hoofdgemeenten}
                onChange={onChange}
                disabled={disabled}
                value={gemeente}
                validationMessage={errors ? errors : ""}
                validationMessageType={validationMessageType}
            />
            <PlusMinButtons
                minButtonEnabled={minButtonEnabled && !disabled}
                plusButtonEnabled={plusButtonEnabled && !disabled}
                onMinButtonClick={onMinButtonClick}
                onPlusButtonClick={onPlusButtonClick}
                size={1}
            />
        </Row>
    );
};

GemeenteComponent.propTypes = {
    gemeente: PropTypes.string,
    hoofdgemeenten: PropTypes.array,
    minButtonEnabled: PropTypes.bool,
    plusButtonEnabled: PropTypes.bool,
    disabled: PropTypes.bool,
    onPlusButtonClick: PropTypes.func.isRequired,
    onMinButtonClick: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    index: PropTypes.number,
    errors: PropTypes.object,
    validationMessageType: PropTypes.string
};

export default GemeenteComponent;